/**
 *
 * @param {HTMLElement[]} targets
 * @param {() => void} callback
 * @param {('DOMNodeRemoved' | 'DOMAttrModified' | 'DOMSubtreeModified')[]} events
 * @param {{once: boolean | undefined}} option
 * @return {void}
 */
export function handleMutationEvent (targets, callback, events, option = {}) {
  events.forEach((event) => {
    /**
     *
     * @type {MutationObserver | null}
     */
    let observer = null;
    /**
     *
     * @type {MutationObserverInit | null}
     */
    let config = null;

    switch (event) {
      case 'DOMNodeRemoved':
        observer = new MutationObserver((mutations) => {
          let isCallbackCalled = false;
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
              isCallbackCalled || callback();
              isCallbackCalled = true;
              if (option.once) {
                observer.disconnect();
              }
            }
          });
        });
        config = { childList: true };
        break;
      case 'DOMAttrModified':
        observer = new MutationObserver((mutations) => {
          let isCallbackCalled = false;
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
              isCallbackCalled || callback();
              isCallbackCalled = true;
              if (option.once) {
                observer.disconnect();
              }
            }
          });
        });
        config = { attributes: true };
        break;
      case 'DOMSubtreeModified' :
        observer = new MutationObserver((mutations) => {
          let isCallbackCalled = false;
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              isCallbackCalled || callback();
              isCallbackCalled = true;
              if (option.once) {
                observer.disconnect();
              }
            }
          });
        });
        config = { childList: true, subtree: true };
        break;
    }

    if (observer && config) {
      targets.forEach(target => observer.observe(target, config));
    }
  });
}
